export const locale = {
  lang: 'nl',
  data: {
    PROSPECTS: {
      FIRST_NAME: 'Voornaam',
      LAST_NAME: 'Achternaam',
      COMPANY_NAME: 'Bedrijfsnaam',
      STATUS: 'Status',
      CREATED_AT: 'Datum aanmelding',
      STATUS_1: 'In afwachting',
      STATUS_4: 'Afgekeurd',
      STATUS_7: 'Geaccepteerd',
      STATUS_9: 'Verwerkt',
      SEARCH: 'Zoeken',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/content/prospects/i18n/nl.ts